<div class="container">
  <div class="row mb-5">
    <app-card-container>
      <div class="col-12" [innerHtml]="content"></div>
    </app-card-container>

  </div>
</div>
